import type { HTMLAttributes, ReactNode } from 'react';
import './Badge.css';

export type BadgeTone =
  | 'neutral'
  | 'info'
  | 'correct'
  | 'incorrect'
  | 'partial'
  | 'warning'
  | 'bronze'
  | 'silver'
  | 'gold'
  | 'platinum';

const TONE: Record<BadgeTone, string> = {
  neutral: 'var(--text-secondary)',
  info: 'var(--info)',
  correct: 'var(--correct)',
  incorrect: 'var(--incorrect)',
  partial: 'var(--partial)',
  warning: 'var(--warning)',
  bronze: 'var(--div-bronze)',
  silver: 'var(--div-silver)',
  gold: 'var(--div-gold)',
  platinum: 'var(--div-platinum)',
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  variant?: 'solid' | 'outline';
  /** Show a leading status dot. */
  dot?: boolean;
  children?: ReactNode;
}

export function Badge({
  children,
  tone = 'neutral',
  variant = 'outline',
  dot = false,
  style,
  ...rest
}: BadgeProps) {
  const color = TONE[tone];
  const styleObj =
    variant === 'solid'
      ? { background: color, borderColor: color, color: 'var(--text-on-accent)', ...style }
      : { color, borderColor: color, background: 'transparent', ...style };
  return (
    <span className={`uc-badge uc-badge--${variant}`} style={styleObj} {...rest}>
      {dot && (
        <span
          className="uc-badge__dot"
          style={variant === 'solid' ? { background: 'var(--text-on-accent)' } : undefined}
        />
      )}
      {children}
    </span>
  );
}
